module.exports = __webpack_public_path__ + "img/purchase-icon-active.b3361781.svg";